// DS1.13
import React from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { Url } from '@wix/da-url';
import s from './Loader.scss';
const Loader = ({ size, state = 'loading', className })=>{
    // override the default loading state with the dabirthday_2025 special animation
    const dabirthday_2025 = useFlag('dabirthday_2025');
    const pride25 = useFlag('pride25');
    if (state === 'loading' && pride25) {
        state = 'pride';
    }
    if (state === 'loading' && dabirthday_2025) {
        state = 'balloons';
    }
    const getImagePath = (state)=>({
            loading: 'loading/llama-med.gif',
            laying_eggs: 'loading/llama-egg.gif',
            static: 'loading/llama-static.png?2',
            static_color: 'loading/llama-static.gif?2',
            disabled: 'loading/llama-disabled.png',
            popcorn: 'loading/llama-popcorn.gif',
            eating: 'loading/llama-eating.gif',
            eating_grass: 'loading/llama-eating-grass.gif?1',
            spitting: 'loading/llama-spitting.gif',
            skeleton: 'loading/llama-skeleton.gif',
            valentines: 'loading/llama-love.gif',
            balloons: 'loading/llama-with-balloons2.gif',
            holiday: 'loading/llama-prancing.gif',
            pride: 'loading/llama-pride22.gif'
        })[state];
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s[size], s[state], className)
    }, /*#__PURE__*/ React.createElement("img", {
        src: Url.staticCDNLink(getImagePath(state)),
        alt: "",
        className: s['llama']
    }));
};
Loader.displayName = 'Loader';
export default Loader;

//# sourceMappingURL=Loader.js.map